import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthletePackageHold, AthletePackageHoldWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateAthletePackageHold(): UseMutationResult<
  AxiosResponse<AthletePackageHold>,
  AxiosError<ErrorMessage>,
  AthletePackageHoldWrite
> {
  const queryClient = useQueryClient();

  const updateAthletePackageHold = (
    athletePackageHold: AthletePackageHoldWrite,
  ): Promise<AxiosResponse<AthletePackageHold>> => {
    return client.put(
      `athlete-package-holds/${athletePackageHold.athletePackageHoldId}/`,
      athletePackageHold,
    );
  };

  return useMutation(updateAthletePackageHold, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athletePackages'],
      });
      queryClient.invalidateQueries({
        queryKey: ['invoices'],
      });
      queryClient.invalidateQueries({
        queryKey: ['athleteEvents'],
      });
    },
  });
}
